// WP50 P5b dashboard: Refresh reloads every widget (each one listens for dash-refresh), a widget that failed to load offers
// Retry, and the Customize sheet moves widgets with the arrow buttons or Alt+Up / Alt+Down. No inline script (CSP).

const fire = (el: Element, name: string) => el.dispatchEvent(new CustomEvent(name));

document.addEventListener("click", (ev) => {
  const target = ev.target instanceof Element ? ev.target : null;
  if (!target) return;
  if (target.closest("[data-dash-refresh]")) { fire(document.body, "dash-refresh"); return; }
  const retry = target.closest("[data-dash-retry]")?.closest("[data-widget]");
  if (retry) { fire(retry, "dash-retry"); return; }
  const move = target.closest<HTMLElement>("[data-move]");
  if (move) moveRow(move, move.dataset.move === "up");
});

document.addEventListener("keydown", (ev) => {
  if (!ev.altKey || (ev.key !== "ArrowUp" && ev.key !== "ArrowDown")) return;
  const el = ev.target instanceof HTMLElement ? ev.target : null;
  if (!el?.closest("[data-customize-list]")) return;
  ev.preventDefault();
  moveRow(el, ev.key === "ArrowUp");
});

function moveRow(from: HTMLElement, up: boolean) {
  const row = from.closest("li");
  const other = up ? row?.previousElementSibling : row?.nextElementSibling;
  if (!row || !other) return;
  if (up) other.before(row); else other.after(row);
  from.focus();
}

// A widget whose request failed keeps its place and says so, with a Retry that reloads only that widget.
function failed(ev: Event) {
  const widget = ev.target instanceof Element ? ev.target.closest("[data-widget]") : null;
  const body = widget?.querySelector(".widget-body");
  if (!widget || !body) return;
  widget.setAttribute("aria-busy", "false");
  body.innerHTML = "";
  const p = document.createElement("p");
  p.className = "widget-empty is-error";
  p.textContent = "Couldn't load this. ";
  const button = document.createElement("button");
  button.type = "button";
  button.className = "widget-link";
  button.dataset.dashRetry = "";
  button.textContent = "Retry";
  p.append(button);
  body.append(p);
}
document.addEventListener("htmx:responseError", failed);
document.addEventListener("htmx:sendError", failed);
